import { $http } from 'boot/axios'

export class offersRepository {
  static async getDiscoveryOffers(payload) {
    const { shopId } = payload
    return $http.post(`/discoveroffers/available`, { shopId })
  }
}
